const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/auth';

const handleError = async (response, defaultMessage) => {
    const data = await response.json();
    console.log('data', data)
    throw new Error(data?.error || data?.error || defaultMessage);
};

export const sendWhatsappVerificationCode = async (phone) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/customer/send-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ phone }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء إرسال رمز التحقق عبر واتساب");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء إرسال رمز التحقق");
    }
};

export const customerLogin = async (phone, code) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/customer/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ phone, code }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء تسجيل الدخول");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء تسجيل الدخول");
    }
};

export const login = async (email, password) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include",
            body: JSON.stringify({ email, password }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء تسجيل الدخول");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء تسجيل الدخول");
    }
};

export const sendEmailVerificationCode = async (email) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/send-verification-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء إرسال رمز التحقق");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء إرسال رمز التحقق");
    }
};

export const customerRegister = async (phone, code, name) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/customer/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ phone, code, name }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء التسجيل");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء التسجيل");
    }
};

export const institutionRegister = async (formData) => {
    const admin = {
        name: formData.adminName,
        email: formData.email,
        password: formData.password,
        verificationCode: formData.verificationCode,
    };

    const institution = {
        name: formData.entityName,
        workStartTime: formData.workStartTime,
        workEndTime: formData.workEndTime,
        commercialRegisterNumber: formData.commercialRegisterNumber,
        licenseNumber: formData.licenseNumber,
    };

    const workingDays = formData.workingDays;

    try {
        const response = await fetch(`${BASE_URL}${API_URL}/institution/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ admin, institution, workingDays }),
        });

        if (!response.ok) {
            return handleError(response, "حدث خطأ أثناء تسجيل المؤسسة");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء تسجيل المؤسسة");
    }
};

export const getInvitationInfo = async (token) => {
    try {
        const response = await fetch(`${BASE_URL}/auth/employee/invitation-details`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
        });

        const json = await response.json();

        if (!response.ok) {
            throw new Error(json?.message || "حدث خطأ أثناء جلب بيانات الدعوة");
        }

        return json.data;
    } catch (error) {
        throw new Error(error?.message || "حدث خطأ غير متوقع أثناء جلب بيانات الدعوة");
    }
};
